/**
 * useBeautyAssistantSession
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import BeautyAssistantSessionContext from './beauty-assistant-sessions-context'

const useBeautyAssistantSession = () => {
  const context = useContext(BeautyAssistantSessionContext)
  return context
}

export default useBeautyAssistantSession
